export default __webpack_public_path__ + "static/media/recycled-hs.b0437472.svg";